module.exports = __webpack_public_path__ + "static/media/map.589c7bb5.png";